import { catalogEntryForProviderSlug } from './walletCatalog';
import { WALLET_ICON_OVERRIDES } from './walletIconAssets';
import { getCwyWalletAdapter } from '../providers/solanaAdapters';

/** Square wallet icons — overrides adapter defaults when those are non-square or low quality. */
export { WALLET_ICON_OVERRIDES, getWalletIconDisplay } from './walletIconAssets';

export function resolveWalletIcon(slug: string, adapterIcon?: string): string | undefined {
  return WALLET_ICON_OVERRIDES[slug] ?? adapterIcon;
}

/** Official brand icon from the installed wallet adapter (original colours). */
export function resolveProviderIcon(slug?: string): string | undefined {
  if (!slug) return undefined;
  const entry = catalogEntryForProviderSlug(slug);
  if (!entry) return WALLET_ICON_OVERRIDES[slug];
  const adapter = getCwyWalletAdapter(entry.adapterName);
  return WALLET_ICON_OVERRIDES[slug] ?? adapter?.icon;
}
